export const ProfileType = {
  SuperAdmin: -2, // super-admin
  SuperAdminLimited: 100, // super-admin limited
  RegistrationWaiting: -1, //
  OrgAdminTrial: 0, // different org page
  OrgAdmin: 1, // different org page
  OrgUser: 2, // different org page
  MemberAdminTrial: 10, // club page
  MemberAdmin: 11, // club page
  MemberUser: 12, // club page
}

export const SuperAdminProfileTypes = [ProfileType.SuperAdmin, ProfileType.SuperAdminLimited]

export function isFullSuperAdminProfileType(profileType) {
  return profileType === ProfileType.SuperAdmin
}

export function isSuperAdminLimitedProfileType(profileType) {
  return profileType === ProfileType.SuperAdminLimited
}

export function isSuperAdminProfileType(profileType) {
  return SuperAdminProfileTypes.includes(profileType)
}
